



























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class IconbarSidepanel extends Vue {

  sidePanelWidth: string = '';
  getCurrentUrl = window.location.pathname.slice(11);

  hideSidepanel() {
    this.$emit('closingSidepanel');
  }

  @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
    this.getCurrentUrl = window.location.pathname.slice(11);
  }
}

